import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClientFilterComponent} from './client-filter.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule} from '@angular/forms';
import {MaterialModule} from '../../material.module';

@NgModule({
    declarations: [
        ClientFilterComponent
    ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        FormsModule,
        MaterialModule
    ],
    exports: [
        ClientFilterComponent
    ]
})
export class ClientFilterModule {
}
